<template>
  <IconWrapper :dense="dense">
    <svg
      :class="{ disable }"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      v-on="!disable && $listeners"
    >
      <path
        d="M13.725 4.28254C13.4325 3.99004 12.96 3.99004 12.6675 4.28254L9.00004 7.94254L5.33254 4.27504C5.04004 3.98254 4.56754 3.98254 4.27504 4.27504C3.98254 4.56754 3.98254 5.04004 4.27504 5.33254L7.94254 9.00004L4.27504 12.6675C3.98254 12.96 3.98254 13.4325 4.27504 13.725C4.56754 14.0175 5.04004 14.0175 5.33254 13.725L9.00004 10.0575L12.6675 13.725C12.96 14.0175 13.4325 14.0175 13.725 13.725C14.0175 13.4325 14.0175 12.96 13.725 12.6675L10.0575 9.00004L13.725 5.33254C14.01 5.04754 14.01 4.56754 13.725 4.28254Z"
      />
    </svg>
  </IconWrapper>
</template>

<script>
import IconWrapper from './IconWrapper'

export default {
  components: {
    IconWrapper
  },

  props: {
    dense: Boolean,
    disable: Boolean
  }
}
</script>

<style lang="scss" scoped>
svg {
  &:not(.disable) {
    cursor: pointer;
  }

  path {
    fill: var(--r-secondary-1);
  }

  &.disable path {
    fill: var(--r-white-5);
  }
}
</style>
